import { styled } from '@material-ui/core';

export const AppliedCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
}));
